<div class="my-2">
	<app-checkbox
		[disabled]="
			(showMatterTypes.length > 0 &&
				!showMatterTypes.includes(MatterFileType.SALE)) ||
			disabled
		"
		type="clear"
		[ngModel]="documentAvailableInSale"
		(ngModelChange)="onDocumentAvailableInSaleChange($event)"
		>Sale</app-checkbox
	>
</div>

<div class="my-2">
	<app-checkbox
		[disabled]="
			(showMatterTypes.length > 0 &&
				!showMatterTypes.includes(MatterFileType.PURCHASE)) ||
			disabled
		"
		type="clear"
		[ngModel]="documentAvailableInPurchase"
		(ngModelChange)="onDocumentAvailableInPurchaseChange($event)"
		>Purchase</app-checkbox
	>
</div>

<div class="my-2">
	<app-checkbox
		[disabled]="
			(showMatterTypes.length > 0 &&
				!showMatterTypes.includes(MatterFileType.REFINANCE)) ||
			disabled
		"
		type="clear"
		[ngModel]="documentAvailableInRefinance"
		(ngModelChange)="onDocumentAvailableInRefinanceChange($event)"
		>Refinance</app-checkbox
	>
</div>
